<div class="discounted-items-modal">

  <!-- Header -->
  <div class="flex items-center justify-between px-6 py-5 border-b border-gray-100 bg-[#F8F9FA]">
    <h2 class="text-xl font-bold text-[#101828] tracking-tight">
      Discounted Items
    </h2>
    <button
      (click)="close()"
      class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-200 transition-colors duration-150 text-zestBlack"
      aria-label="Close"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-5 h-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2.5"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  <!-- Product List -->
  <div class="px-6 py-2 overflow-y-auto max-h-[60vh]">
    <div
      *ngFor="let item of data.productDetails; let last = last"
      class="flex items-center py-5 gap-4"
      [ngClass]="{ 'border-b border-gray-100': !last }"
    >

      <!-- Product Image -->
      <div class="flex-shrink-0 w-[90px] h-[90px] rounded-lg overflow-hidden bg-gray-50 border border-gray-100">
        <img
          *ngIf="item.productImage; else noImage"
          [src]="item.productImage"
          [alt]="item.productName"
          class="w-full h-full object-cover"
        />
        <ng-template #noImage>
          <div class="w-full h-full flex items-center justify-center bg-gray-100">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
        </ng-template>
      </div>

      <!-- Product Name & Category -->
      <div class="flex-1 min-w-0">
        <p class="font-medium text-[#101828] text-base leading-snug truncate">
          {{ item.productName }}
        </p>
        <p class="text-sm text-gray-400 mt-0.5 truncate">
          {{ item.discountReason || '&nbsp;' }}
        </p>
      </div>

      <!-- Pricing -->
      <div class="flex-shrink-0 text-right">
        <!-- Final (discounted) amount -->
        <p class="font-bold text-[#101828] text-base leading-snug">
          {{ item.finalAmount | currency : "₦ " }}
        </p>
         <!-- Original amount × quantity  -->
        <p class="text-sm text-gray-400 mt-0.5 line-through">
          {{ item.originalAmount | currency : "₦ " }} &times; {{ item.itemQuantity }} {{ item.itemQuantity === 1 ? 'Item' : 'Items' }}
        </p>
      </div>

    </div>
  </div>

</div>